import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UniqService {
  /**
   * Removes duplicate values from an array
   * @param array The array to remove duplicates from
   * @returns A new array with duplicates removed
   */
  static uniq<T>(array: T[]): T[] {
    return Array.from(new Set(array));
  }
}
